import { Component, input } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'agenda-customer-ui-shimmer-fragment',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './shimmer-fragment.component.html',
  styleUrls: ['./shimmer-fragment.component.scss'],
})
export class ShimmerFragmentComponent {
  type = input.required<'rectangle' | 'circle'>();
  width = input<'55' | '65' | '75' | '85' | '90' | '95' | '100'>('100');
  height = input<'20' | '25' | '35' | '90'>('20');
  marginBottom = input<'5' | '10' | '15' | '20'>('5');
  marginTop = input<'0' | '5' | '10' | '15' | '20'>('0');
}
